<template>
  <div id="app">
    <SiteNav/>
    <main class="app-main">
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
    </main>
    <SiteFooter/>
    <button class="to-top" :class="{ 'is-show': showTop }" aria-label="回到顶部" @click="toTop">
      <IconSvg name="arrow-up"/>
    </button>
  </div>
</template>

<script>
import SiteNav from '@/components/layout/SiteNav'
import SiteFooter from '@/components/layout/SiteFooter'
import IconSvg from '@/components/common/IconSvg'

export default {
  name: 'App',
  components: { SiteNav, SiteFooter, IconSvg },
  data() {
    return { showTop: false }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.showTop = window.pageYOffset > 600
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">
.app-main { min-height: 60vh; }

/* 路由切换过渡 */
.page-enter-active, .page-leave-active { transition: opacity 0.34s ease, transform 0.34s ease; }
.page-enter { opacity: 0; transform: translateY(14px); }
.page-leave-to { opacity: 0; transform: translateY(-8px); }

.to-top {
  --ico: 20px;
  position: fixed;
  right: 26px;
  bottom: 32px;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--line-strong);
  background: rgba(11, 23, 48, 0.85);
  backdrop-filter: blur(10px);
  color: var(--cyan);
  cursor: pointer;
  opacity: 0;
  transform: translateY(12px);
  pointer-events: none;
  transition: all 0.35s;
  z-index: 900;

  &.is-show { opacity: 1; transform: none; pointer-events: auto; }
  &:hover { border-color: var(--cyan); box-shadow: var(--glow-cyan); }

  svg { width: 20px; height: 20px; }
}

@media (max-width: 760px) {
  .to-top { right: 16px; bottom: 20px; width: 40px; height: 40px; }
}
</style>
